<template>
<div class="full-screen-overlay d-flex justify-content-center align-items-center w-100 h-100 position-fixed top-0 start-0" style="background-color: rgba(13, 20, 27, 0.9); z-index: 2000;" @click="toggleFullScreen(false)">
    <div class="full-screen-container position-relative" @click.stop>
      <div class="img-section-name">
        <img
          :src="getImageUrl(image)"
          class="full-screen-image w-100"
          alt="Full Screen Image"
        />
        <div class="body section-name-mob">{{ currentSectionName }}</div>
      </div>
      <div class="image-info">
        <div class="section-name">{{ currentSectionName }}</div>
        <div class="caption image-counter-desktop">
          {{ currentIndex + 1 }}/{{ totalImages }}
        </div>
      </div>
      <div class="nav-controls-desktop position-absolute top-50 d-flex justify-content-between">
        <button @click="moveToPrevImage" class="nav-button d-flex align-items-center justify-content-center">
          <svg width="21" height="18" class="icon">
            <use xlink:href="#___icon___chevron-left-bold"></use>
          </svg>
        </button>
        <button @click="moveToNextImage" class="nav-button d-flex align-items-center justify-content-center">
          <svg width="21" height="18" class="icon">
            <use xlink:href="#___icon___chevron-right-bold"></use>
          </svg>
        </button>
      </div>
      <div class="nav-controls-mobile">
        <button @click="moveToPrevImage" class="nav-button d-flex align-items-center justify-content-center">
          <svg width="21" height="18" class="icon">
            <use xlink:href="#___icon___chevron-left-bold"></use>
          </svg>
        </button>
        <div class="caption bg-light p-2 rounded-pill">
          {{ currentIndex + 1 }}/{{ totalImages }}
        </div>
        <button @click="moveToNextImage" class="nav-button d-flex align-items-center justify-content-center">
          <svg width="21" height="18" class="icon">
            <use xlink:href="#___icon___chevron-right-bold"></use>
          </svg>
        </button>
      </div>
      <button @click="toggleFullScreen(false)" class="close-fullscreen">
        <svg width="21" height="21" class="icon">
          <use xlink:href="#___icon___close-x"></use>
        </svg>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    image: Object,
    currentIndex: Number,
    totalImages: Number,
    currentSectionName: String,
  },
  data() {
    return {
      localCurrentIndex: this.currentIndex,
      localTotalImages: this.totalImages,
      isFullScreen: false,
    };
  },
  methods: {
    getImageUrl(image) {
      return image.imgXL || image.imgLarge || image.img;
    },
    toggleFullScreen(value) {
      this.$emit("toggleFullScreen", value);
    },
    moveToPrevImage() {
      if (this.localCurrentIndex > 0) {
        this.localCurrentIndex--;
        this.$emit("updateIndex", this.localCurrentIndex);
      }
    },
    moveToNextImage() {
      if (this.localCurrentIndex < this.localTotalImages - 1) {
        this.localCurrentIndex++;
        this.$emit("updateIndex", this.localCurrentIndex);
      }
    },
  },
  watch: {
    currentIndex(newVal) {
      this.localCurrentIndex = newVal;
    },
    totalImages(newVal) {
      this.localTotalImages = newVal;
    },
  },
};
</script>

<style scoped>
.full-screen-container {
  width: 40%;
}

.full-screen-image {
  height: auto;
  object-fit: contain;
  border-radius: 8px;
}

.nav-controls-desktop {
  transform: translateY(-50%);
  width: calc(100% + 100px);
  left: -50px; /* Extend controls outward to align with wider images */
}

.nav-controls-mobile {
  display: none;
}

.nav-button {
  border-radius: 32px;
  border: 1px solid var(--grey-grey-300, #dee2e6);
  background: rgba(255, 255, 255, 0.9);
  border: none;
  cursor: pointer;
  width: 30px;
  height: 30px;
}

.close-fullscreen {
  position: absolute;
  right: -40px; /* Adjusted to be closer to the edge */
  top: -50px; /* Adjusted to be above the container */
  background: none;
  border: none;
  cursor: pointer;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: #f1f3f5;
}

.image-info {
  position: absolute;
  width: 100%;
  display: flex;
  justify-content: space-between;
  color: white;
  font-size: 16px;
  box-sizing: border-box;
}

.section-name,
.image-counter-desktop {
  padding: 5px 10px;
  border-radius: 5px;
}

@media (max-width: 1000px) {
  .full-screen-container {
    width: auto; /* Changed to 'auto' to adjust based on the image width */
  }
}
@media (max-width: 768px) {
  .full-screen-overlay {
    align-items: center;
    padding: 20px 0;
  }

  .full-screen-container {
    width: 90%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    /* max-width: calc(90%); Maximum width of the container to fit the image */
  }

  .full-screen-image {
    max-width: 100%;
    max-height: 520px;
    height: auto;
    margin: auto;
  }

  .nav-controls-mobile {
    position: absolute;
    bottom: 60px;
    left: 0;
    right: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .image-counter-desktop,
  .nav-controls-desktop {
    display: none !important;
  }

  .close-fullscreen {
    position: absolute;
    right: 5px;
    top: 10px;
    z-index: 2100;
  }

  .img-section-name {
    display: block;
    align-items: center;
    width: 100%;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    align-self: stretch;
    color: var(--white, #fff);
    font-variant-numeric: lining-nums proportional-nums;
    font-feature-settings: "clig" off, "liga" off;
  }

  .section-name-mob {
    margin-top: 15px;
  }

  .section-name {
    display: none;
  }

  .caption {
    font-size: 14px;
    color: black;
  }
}
</style>
